export const CREATE_JOB = `
  mutation CreateJob($job: jobs_insert_input!) {
    insert_jobs_one(object: $job) {
      id
      job_title
      job_type
      job_type_id
      job_type_rel { id name is_project_based }
      job_status
      project_number
      teknopark_unit
      forward_to_argenet
      contract_id
      firm_id
      firm_short_name
      firm_established
      description_of_job
      created_by
      created_at
    }
  }
`;

export const UPDATE_JOB = `
  mutation UpdateJob($id: uuid!, $job: jobs_set_input!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: $job) {
      id
      job_title
      job_type
      job_type_id
      job_type_rel { id name is_project_based }
      project_number
      teknopark_unit
      forward_to_argenet
      contract_id
      firm_id
      firm_short_name
      firm_established
      description_of_job
      updated_at
    }
  }
`;

export const DELETE_JOB = `
  mutation DeleteJob($id: uuid!) {
    delete_jobs_by_pk(id: $id) {
      id
    }
  }
`;

export const UPDATE_JOB_STATUS = `
  mutation UpdateJobStatus($id: uuid!, $job_status: job_status_enum!, $project_number: Int, $teknopark_unit: String) {
    update_jobs_by_pk(
      pk_columns: { id: $id }
      _set: { job_status: $job_status, project_number: $project_number, teknopark_unit: $teknopark_unit }
    ) {
      id
      job_status
      project_number
      teknopark_unit
      updated_at
    }
  }
`;

// ArgeNet'e ilet anahtari. true olunca ArgeNet'teki sync cron bu isi
// AR-GE birimi olarak ceker; isaret kaldirilsa bile oradaki birim silinmez
// (altina proje/gider verisi girilmis olabilir).
//
// forwarded_to_argenet_at (ilk isaretleme damgasi) BILINCLI olarak geri
// istenmiyor: o kolon yalnizca sync rolune acik, arayuz rollerinde yok.
// Istenirse Hasura "field not found" hatasi veriyor.
export const UPDATE_JOB_FORWARD_TO_ARGENET = `
  mutation UpdateJobForwardToArgenet($id: uuid!, $forward_to_argenet: Boolean!) {
    update_jobs_by_pk(
      pk_columns: { id: $id }
      _set: { forward_to_argenet: $forward_to_argenet }
    ) {
      id
      forward_to_argenet
    }
  }
`;

export const UPDATE_JOB_TEKNOPARK_UNIT = `
  mutation UpdateJobTeknoparkUnit($id: uuid!, $teknopark_unit: String) {
    update_jobs_by_pk(
      pk_columns: { id: $id }
      _set: { teknopark_unit: $teknopark_unit }
    ) {
      id
      teknopark_unit
      updated_at
    }
  }
`;

export const UPDATE_JOB_REPORTING_PLAN = `
  mutation UpdateJobReportingPlan($id: uuid!, $updateFields: jobs_set_input!) {
    update_jobs_by_pk(
      pk_columns: { id: $id }
      _set: $updateFields
    ) {
      id
      post_approval_report_required
      post_completion_report_required
      job_reports
      updated_at
    }
  }
`;

export const UPDATE_JOB_PROJECT_DATES = `
  mutation UpdateJobProjectDates($id: uuid!, $set: jobs_set_input!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      job_title
      project_extensions
    }
  }
`;

// "Mali sorumlu istenmiyor" aksiyonu: iş atamaları satır aksiyonundan
// çağrılır. true yapılınca useJobAssignments mali eksik uyarısını bastırır
// ve pending financial request yaratılmaz.
export const UPDATE_JOB_NO_FINANCIAL_NEEDED = `
  mutation UpdateJobNoFinancialNeeded($id: uuid!, $value: Boolean!) {
    update_jobs_by_pk(
      pk_columns: { id: $id }
      _set: { no_financial_needed: $value }
    ) {
      id
      no_financial_needed
    }
  }
`;

export const CREATE_JOB_DETAIL = `
  mutation CreateJobDetail($job_id: uuid!, $job_detail_type: String!, $detail_data: jsonb!, $created_by: Int!) {
    insert_job_details_one(object: {
      job_id: $job_id
      job_detail_type: $job_detail_type
      detail_data: $detail_data
      created_by: $created_by
    }) {
      id
      job_id
      job_detail_type
      detail_data
      created_by
      created_at
      updated_at
    }
  }
`;

export const UPDATE_JOB_TAGS = `
  mutation UpdateJobTags($job_id: uuid!, $objects: [job_tags_insert_input!]!) {
    # First delete existing tags
    delete_job_tags(where: { job_id: { _eq: $job_id } }) {
      affected_rows
    }
    # Then insert new tags
    insert_job_tags(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_JOB_TAGS = `
  mutation DeleteJobTags($job_id: uuid!) {
    delete_job_tags(where: { job_id: { _eq: $job_id } }) {
      affected_rows
    }
  }
`;

export const UPDATE_TEAM_TAGS = `
  mutation UpdateTeamTags($team_id: Int!, $objects: [team_tags_insert_input!]!) {
    delete_team_tags(where: { team_id: { _eq: $team_id } }) {
      affected_rows
    }
    insert_team_tags(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_GROUP_TAGS = `
  mutation UpdateGroupTags($group_id: Int!, $objects: [group_tags_insert_input!]!) {
    delete_group_tags(where: { group_id: { _eq: $group_id } }) {
      affected_rows
    }
    insert_group_tags(objects: $objects) {
      affected_rows
    }
  }
`;
